export const tr = {
    active: 'Veri toplanıyor...',
    'active-text': 'Ara sonuçlar hazır fakat nihai sonuçlardan farklılık gösterebilir.',
    brandlift: 'Brand Lift Araştırması',
    cancel: 'İptal',
    close: 'Kapat',
    completed: 'Anket tamamlandı.',
    draft: 'Taslaktır.',
    'draft-text': 'Veri toplama, araştırmanın kontrolü yapıldıktan sonra başlayacak.',
    moderation: 'Moderasyona gönderildi.',
    'moderation-text': 'Veri toplama, araştırmanın kontrolü yapıldıktan sonra başlayacak.',
    'more-info-link': 'Daha fazla bilgi',
    params: 'Araştırma parametreleri',
    reject: 'Araştırma moderasyon sonucunda reddedildi.',
    result: 'Araştırma sonuçları',
    save: 'Kaydet',
    stop: 'Anket durduruldu.',
    'stop-budget': 'Kampanyanın tahmini bütçesi {budgetThreshold}{currencySymbol} tutarının altında.',
    'stop-budget-and-coverage':
        'Kampanyanın tahmini bütçesi ve hedef kitle kapsamı minimum eşik değerlerinin altında. {moreInfoLink}.',
    'stop-coverage': 'Kampanya kapsamının 2 milyondan az olması öngörülüyor.',
    'stop-research': 'Araştırmayı iptal et'
};
